import FeatherIcon from 'feather-icons-react';

export const NoticePreviewFrame = ({ propertyName, address, unitNumber, noticeType, metadata, tagline, children, label = 'Preview - Email to resident' }) => (
  <section className="pm-preview-frame" aria-label={label}>
    <header className="pm-preview-toolbar"><span><FeatherIcon icon="eye" size={18} />{label}</span><span className="pm-preview-channel"><FeatherIcon icon="mail" size={15} />Email</span></header>
    <div className="pm-preview-paper">
      <div className="pm-property-banner" style={{ backgroundImage: `linear-gradient(90deg, rgba(12, 29, 42, .92) 0%, rgba(12, 29, 42, .55) 48%, rgba(12, 29, 42, .25) 100%), url("${process.env.PUBLIC_URL || ''}/images/premoveout-notice-interior.png")` }}>
        <div className="pm-banner-copy">
          <div className="pm-banner-meta"><span className="pm-banner-eyebrow">{noticeType}</span>{metadata ? <span>{metadata}</span> : null}</div>
          <div className="pm-banner-property"><strong>{propertyName || 'Your property team'}</strong><span className="pm-banner-unit"><FeatherIcon icon="home" size={14} />Unit {unitNumber}</span></div>
          {address && <span className="pm-banner-address">{address}</span>}
        </div>
        {tagline && <p className="pm-banner-tagline">{tagline}</p>}
      </div>
      {children}
    </div>
  </section>
);

export const NoticeContact = ({ contact, companyName }) => (
  <div className="pm-letter-signature">
    <p>Warm regards,</p>
    <strong>{contact?.name || 'Your property team'}</strong>
    <span>{companyName || 'Your Property Management Team'}</span>
    <a href={contact?.phoneHref || undefined}><FeatherIcon icon="phone" size={15} />{contact?.phone || 'Contact phone'}</a>
    <a href={contact?.email ? `mailto:${contact.email}` : undefined}><FeatherIcon icon="mail" size={15} />{contact?.email || 'Contact email'}</a>
    <p className="pm-letter-thanks">Thank you for being a valued resident.</p>
  </div>
);
